/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PromotionTagAdditionalInfoPost = {
  discountType: PromotionTagAdditionalInfoPost.discountType;
  value: number;
  typeIncluded: PromotionTagAdditionalInfoPost.typeIncluded;
  fieldIDsIncluded: Array<number>;
  typeExcluded?: PromotionTagAdditionalInfoPost.typeExcluded;
  fieldIDsExcluded?: Array<number>;
};

export namespace PromotionTagAdditionalInfoPost {

  export enum discountType {
    AMOUNT = 'AMOUNT',
    PERCENTAGE = 'PERCENTAGE',
    FORCED_PRICE = 'FORCED_PRICE',
  }

  export enum typeIncluded {
    BUSINESS_PARTNER_GROUP = 'BUSINESS_PARTNER_GROUP',
    BUSINESS_PARTNER = 'BUSINESS_PARTNER',
    ITEM_GROUP = 'ITEM_GROUP',
    ITEM = 'ITEM',
    PRICE_LIST = 'PRICE_LIST',
    COUPON = 'COUPON',
    CAMPAIGN = 'CAMPAIGN',
    PRICE = 'PRICE',
    LOYALTY_LEVEL = 'LOYALTY_LEVEL',
  }

  export enum typeExcluded {
    BUSINESS_PARTNER_GROUP = 'BUSINESS_PARTNER_GROUP',
    BUSINESS_PARTNER = 'BUSINESS_PARTNER',
    ITEM_GROUP = 'ITEM_GROUP',
    ITEM = 'ITEM',
    PRICE_LIST = 'PRICE_LIST',
    COUPON = 'COUPON',
    CAMPAIGN = 'CAMPAIGN',
    PRICE = 'PRICE',
    LOYALTY_LEVEL = 'LOYALTY_LEVEL',
  }


}
